
class CartBundleLineItem extends HTMLElement {
    constructor() {
        super();
        console.log('cart bundle line item initialized');
    }
    connectedCallback() {
        this.deleteButtons = this.querySelectorAll(".line-item-remove");
        this.quantityInputs = this.querySelectorAll(".js-quantity");

        this.deleteButtons.forEach((button) => {
            button.addEventListener("click", (event) => this.deleteBundle(event));
        });
        this.quantityInputs.forEach((input) => {
            input.addEventListener("change", (event) => this.updateBundleQuantity(event.target.value));
        });
    }

    getBundleKeys() {
        return this.dataset.bundleKeys?.split(",").map((key) => key.trim());
    }

    updateBundleQuantity(value) {
        this.querySelectorAll('.js-hidden-quantity').forEach((input) => {
            input.value = value;
        });
        this.quantityInputs.forEach((input) => {
            input.value = value;
        });
    }

    deleteBundle(event) {
        event.preventDefault();
        if(!confirm("Do you want to delete this bundle?")) {
            return;
        }
        const bundleKeys = this.getBundleKeys();
        let updates = {};
        bundleKeys.forEach((key) => {
            updates[`${key}`] = 0
        });
        console.log('updates', updates);
        this.updateCart(updates)
            .then((response) => {
                window.location.href = `${window.Shopify.routes.root}cart`;
            });
    }

    updateCart(updates) {
        return fetch(`${window.routes.cart_update_url}.js`, {
            body: JSON.stringify({updates}),
            credentials: "same-origin",
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
        })
            .then((resp) => resp.json());
    }
}

customElements.define("bundle-line-item", CartBundleLineItem);